/**
 * Staff screens render the FULL desktop layout on phones too — the same
 * sidebar, tables and tabs as on a laptop, zoomed out to fit, with pinch-zoom
 * to read. A phone simply lays the page out as if it were 1280px wide, so every
 * `innerWidth < 768` check in the app sees a desktop and stays out of the way.
 *
 * Customer-facing pages (order, tracking, complaints), the login and the
 * handover scan desk keep the phone layout: they are built for a phone.
 */
const DESKTOP_WIDTH = 1280;
const DEVICE_VIEWPORT = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
const DESKTOP_VIEWPORT = `width=${DESKTOP_WIDTH}, viewport-fit=cover`;

const PHONE_LAYOUT_PATHS = ['/login', '/track', '/order', '/my-orders', '/handover'];

const keepsPhoneLayout = (pathname) => {
    // track.* serves the public tracking page at its bare root.
    if (/^track\./i.test(String(window.location.hostname || ''))) return true;
    return PHONE_LAYOUT_PATHS.some(p => pathname === p || pathname.startsWith(`${p}/`));
};

// Owner's choice (22 Oct 2026): on a phone the PHONE layout is the default again —
// "mobile version is not showing, only desktop". Anyone can still switch a phone to
// the full desktop layout (zoomed out) and back; the choice is kept per device.
const VIEW_MODE_KEY = 'daksha.viewMode';           // 'phone' (default) | 'desktop'
export const getViewMode = () => {
    try { return localStorage.getItem(VIEW_MODE_KEY) === 'desktop' ? 'desktop' : 'phone'; } catch { return 'phone'; }
};
/** Switch this device between the phone and desktop layouts (reloads to re-lay out). */
export const setViewMode = (mode) => {
    try { localStorage.setItem(VIEW_MODE_KEY, mode === 'desktop' ? 'desktop' : 'phone'); } catch { /* private mode */ }
    window.location.reload();
};
/** A phone-sized screen (the switch is only offered there). */
export const isNarrowScreen = () => Math.min(window.screen?.width || DESKTOP_WIDTH, window.screen?.height || DESKTOP_WIDTH) < DESKTOP_WIDTH;

export const applyViewportFor = (pathname = window.location.pathname) => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;
    // Wide screens already get the desktop layout; only narrow ones need the zoom-out,
    // and only when this device chose the desktop layout.
    const next = isNarrowScreen() && getViewMode() === 'desktop' && !keepsPhoneLayout(pathname) ? DESKTOP_VIEWPORT : DEVICE_VIEWPORT;
    if (meta.getAttribute('content') !== next) meta.setAttribute('content', next);
};
